export default "__VITE_ASSET__FiHT6Rcp__"